const PrePaywallView = () => import(/* webpackChunkName: "pre" */ '@/modules/PrePaywall/PrePaywallView.vue')

export const prePaywallInstances = [
	{
		id: 'prepaywall-personalized-plan',
		path: '/pre/personalized-plan',
		name: 'prepaywall-personalized-plan',
		component: () => import(/* webpackChunkName: "pre" */ './PrePaywallView.vue'),
		config: () => import('./instances/experiments/prepaywall-personalized-plan'),
	},
	{
		id: 'prepaywall-calculated-score',
		path: '/pre/calculated-score',
		name: 'prepaywall-calculated-score',
		component: () => import(/* webpackChunkName: "pre" */ './PrePaywallView.vue'),
		config: () => import('./instances/experiments/prepaywall-calculated-score'),
	},
	{
		id: 'prepaywall-bmi-based',
		path: '/pre/bmi-based',
		name: 'prepaywall-bmi-based',
		component: () => import(/* webpackChunkName: "pre" */ './PrePaywallView.vue'),
		config: () => import('./instances/experiments/prepaywall-bmi-based'),
	},
	{
		id: 'prepaywall-almost-finished',
		path: '/pre/almost-finished',
		name: 'prepaywall-almost-finished',
		component: () => import(/* webpackChunkName: "pre" */ './PrePaywallView.vue'),
		config: () => import('./instances/experiments/prepaywall-almost-finished'),
	},
	{
		id: 'prepaywall-match-for-simple',
		path: '/pre/match-for-simple',
		name: 'prepaywall-match-for-simple',
		component: () => import(/* webpackChunkName: "pre" */ './PrePaywallView.vue'),
		config: () => import('./instances/experiments/prepaywall-match-for-simple'),
	},
	{
		id: 'prepaywall-plan-almost-ready',
		path: '/pre/plan-almost-ready',
		name: 'prepaywall-plan-almost-ready',
		component: () => import(/* webpackChunkName: "pre" */ './PrePaywallView.vue'),
		config: () => import('./instances/experiments/prepaywall-plan-almost-ready'),
	},
	{
		id: 'prepaywall-fsa-hsa',
		path: '/pre/fsa-hsa',
		name: 'prepaywall-fsa-hsa',
		component: () => import(/* webpackChunkName: "pre" */ './PrePaywallView.vue'),
		config: () => import('./instances/experiments/prepaywall-fsa-hsa'),
	},
]

export default prePaywallInstances.map((instance) => ({
	path: `/pre/${instance.id.replace('prepaywall-', '')}`,
	name: instance.id,
	component: {
		render: (h) =>
			h(PrePaywallView, {
				key: instance.id,
				props: {
					id: instance.id,
					config: instance.config,
				},
			}),
	},
	meta: {
		requiresUser: false,
	},
}))
